import { useToken } from "@/hooks/use-token.ts";
import { useQuery } from "@tanstack/react-query";
import { env } from "@/lib/env.ts";
import { z } from "zod";
import { api } from "@/lib/server";

export const machineSchema = z.object({
  id: z.coerce.number(),
  capacity: z.coerce.number(),
  capacityType: z.string(),
  machineType: z.string(),
  offline: z.boolean(),
  price: z.coerce.number(),
  memberPrice: z.coerce.number(),
  shopId: z.coerce.number(),
  socketNumber: z.coerce.number(),
  storePlace: z.coerce.number(),
  syncedAt: z.string().nullable(),
  furFriendly: z.boolean(),
  vegan: z.boolean(),
  moxaId: z.coerce.number(),
  moxaOperatingType: z.coerce.number(),
  usesNats: z.boolean(),
  throwErrorOnStart: z.boolean(),
  isReservable: z.boolean(),
  // shop: shopSchema,
});

export function useMachine(machineId: number) {
  const token = useToken();
  return useQuery({
    queryKey: ["machine", machineId, token],
    enabled: !!machineId,
    queryFn: async () => {
      return await api.machine(machineId);
    },
  });
}
